type ValidateNPSOnCustomFormParams = {
  nps: string
  isRequired?: boolean
}

export default function validateNPSOnCustomForm({ nps, isRequired }: ValidateNPSOnCustomFormParams) {
  let error = ''
  if (isRequired && !nps) {
    error = 'Este campo é obrigatório'
  }

  return error
}
